export const logoSize = {
	md: 'h-8 my-auto',
	lg: 'h-20',
	lx: 'h-10',
	footer:'h-8 my-auto ml-5' 
}
